<template>
    <div class="refundAmount">
        <Head :headInfo='headInfo' @onClickLeft='onBack' />
        <div class="refund_item">
            <div class="title">退款商品<span @click="addEdit" v-show="productLength !== 1 && activityType !== 3">添加和编辑</span></div>
            <div class="refund_good"  v-for="(item, index) in goodList" :key="index">
                <GoodTemplate :goodLength="goodList.length" :goods='item' :apply='true' :showStatus='true' :borderBottom='false' />
            </div>
            <!-- <div class="refund_price">
                <div class="price">退款总金额：<span class="colFF7A45"><sub>¥ </sub>1920.00</span></div>
                <p>(含运费¥ 20元)</p>
            </div> -->
        </div>
        <div class="refund_foot">
            <div class="refund_fixed">
                <div class="refund_btn">
                    <div class="title">退款合计：<span class="colFF7A45"><sub>¥ </sub>{{ totalRefund | NumFormat }}</span>
                    <p v-if="freight!==null">(含运费¥ {{freight}}元)</p>
                    </div>
                </div>
                <div class="refund_submit"  @click="onSubmit"><span>提交</span></div>
            </div>
            <p>(您所使用的满返抵扣，将按实际商品抵扣退回！)</p>
        </div>
    </div>
</template>

<script>
import Head from '../../common/head'
import GoodTemplate from './components/goodTemplate'
import { Dialog } from 'vant'
import { orderTk } from '../api/order'
import NP from 'number-precision'
export default {
    name: 'refundAmount',
    components: {
        Head,
        GoodTemplate
    },
    data () {
        return {
            headInfo: {
                title: '申请退款'
            },
            goodList: [],
            totalMoeny: 0,
            productLength: this.$route.query.productLength || 0,
            activityType: this.$route.query.activityType || 0,
            freight: this.$route.query.freight || null
        }
    },
    computed: {
        totalRefund () {
            return NP.plus(this.totalMoeny, this.freight || 0)
        }
    },
    methods: {
        onBack () {
            this.$router.go(-1)
        },
        addEdit () {
            this.$router.push(
                {
                    path: '/b2b/refundOrder/selectRefund',
                    query: {
                        childOrderId: this.$route.query.childOrderId,
                        productLength: this.$route.query.productLength,
                        freightApi: this.$route.query.freightApi || 0,
                        freight: this.$route.query.freightApi || 0
                    }
                })
        },
        onSubmit () {
            Dialog.confirm({
                title: '提示',
                message: '退款申请提交后,请等待店铺审核',
                confirmButtonText: '提交',
                confirmButtonColor: '#FF7A45'
            }).then(async () => {
                await orderTk({
                    childOrderId: this.$route.query.childOrderId,
                    orderProductIds: this.goodList.map(item => item.id)
                })
                this.$router.replace({ path: localStorage.getItem('goodsDetailBack') })
            }).catch(() => {
            })
        }
    },
    mounted () {
        this.goodList = JSON.parse(localStorage.getItem('refundData'))
        this.totalMoeny = this.goodList.reduce((sum, item) => { return sum + item.finalTotalAmount }, 0)
    }
}
</script>

<style lang="scss" scoped>
.refundAmount {
    padding: 0 16px 180px;
}
.refund_item {
    margin-top: 20px;
    background-color: #ffffff;
    padding: 30px 0 0;
    .title {
        font-size: 28px;
        color: #000000;
        margin-bottom: 24px;
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        span {
            font-size: 32px;
            color: #ff7a45;
        }
    }
    .refund_price {
        padding: 24px 16px;
        background: #ffffff;
        border-top: 2px solid #ededf0;
        font-size: 30px;
        color: #000000;
        text-align: right;
        sub {
            font-size: 20px;
        }
        p {
            font-size: 24px;
            color: #999999;
        }
    }
}
.refund_good {
    padding: 0 16px 48px;
}
.refund_foot {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 24px 16px;
    background: #ffffff;
    box-shadow: 0px 0px 0px 0px #d8d8d8;
    .refund_fixed {
        display: flex;
        align-items: center;
        .refund_btn {
            /* padding: 24px 16px; */
            font-size: 30px;
            color: #000000;
            text-align: right;
            flex: 1;
            sub {
                font-size: 20px;
            }
            p {
                font-size: 24px;
                color: #999999;
                display: inline-block;
                margin-left: 5px;
            }
        }
        .refund_submit {
            width: 210px;
            height: 64px;
            line-height: 64px;
            text-align: center;
            border-radius: 64px;
            background: #ff7a45;
            color: #ffffff;
            font-size: 28px;
            margin-left: 20px;
        }
    }
    p {
        margin-top: 10px;
        text-align: right;
        color: #999999;
    }
}
</style>